'use strict';

var own = {}.hasOwnProperty;
module.exports = own;